import { EditClientDataType } from '../type/EditClientData.type';
import { editClientValidateInitial } from './editClientValidateInitial';

export const editClientDataInitial: EditClientDataType = {
    editInput: null,
    editValidate: editClientValidateInitial,
    editFlag: false,
}